<template>
  <div>
    <nav-bar/>
    <div class="container">
      <div class="row mt-3">
        <div class="col-12">
          <v-data-table
              :headers="headers"
              :items="list"
              :mobile-breakpoint="680"
              :page="pageIndex"
              :items-per-page="pageSize"
              :server-items-length="total"
              :search="search"
              :loading="loading"
              loading-text="درحال بارگذاری... لطفا صبر کنید"
              class="data-table"
              fixed-header
              disable-sort
              show-expand
              :expanded.sync="expanded"
              :single-expand="singleExpand"
              @pagination="pageChangeEvent"
              item-key="SearchItemId">
            <template v-slot:[`item.count`]="{ index}">
              <div>{{ index + 1 }}</div>
            </template>
            <template v-slot:[`item.MainOriginalFileUrl`]="{ item }">
              <div class="p-2 d-flex justify-content-center">
                <v-img v-if="item.MainOriginalFileUrl != null" :src="$replaceHttps(item.MainOriginalFileUrl)" contain
                       height="130" width="130">
                </v-img>
                <v-img v-else :src="getImgUrl(src)" contain
                       height="100" width="100"></v-img>
              </div>
            </template>
            <template v-slot:[`expanded-item`]="{ item }">
              <td>
                <div>
                  <div v-html="item.Description"></div>
                </div>
              </td>
            </template>

            <template v-slot:[`item.TypeSearchResult`]="{ item }">
              <div class="p-2 d-flex justify-content-center">
                {{ $TypeSearchResult[item.TypeSearchResult - 1].name }}
              </div>
            </template>
            <!--          <template v-slot:[`item.NewsCategoryId`]="{  }">-->
            <!--            <div>{{ categoryName }}</div>-->
            <!--          </template>-->


            <template v-slot:[`item.actions`]="{ item }">
              <v-btn
                  class="edit-User"
                  icon
                  dark
                  color="primary"
                  @click="editContent(item.SearchItemId, item.TypeSearchResult)"
              >
                <i class="fas fa-eye ml-1 font-18"></i>
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <FooterComponent/>
  </div>
</template>

<script>
import NavBar from "@/Academy/components/NavBar";
import FooterComponent from "@/Academy/components/Footer";

export default {
  name: "searchResult",
  components: {FooterComponent, NavBar},
  metaInfo () {
    return {
      title: window.projectName + this.$route.name + " " + this.search,
      meta: [
        { //  set meta
          name: 'keywords',
          content: this.$keywords
        },
        { //  set meta
          name: 'description',
          content: this.$description
        },
        {
          property: 'og:title',
          content: window.projectName + this.$route.name + " " + this.search,
          vmid: 'og:title'

        },
        {
          property: 'og:url',
          content: window.location.href,
          vmid: 'og:url'
        },
        {
          property: 'og:description',
          content: this.$description,
          vmid: 'og:description'
        },
        {
          property: 'og:image',
          content: this.$defaultImage,
          vmid: 'og:image'
        },
        {
          property: 'twitter:title',
          content: window.projectName + this.$route.name + " " + this.search,
          vmid: 'twitter:title'
        },
        {
          property: 'twitter:site',
          content: window.location.href,
          vmid: 'twitter:site'
        },
        {
          property: 'twitter:image',
          content: this.$defaultImage,
          vmid: 'twitter:image'
        },
        {
          property: 'twitter:description',
          content: this.$description,
          vmid: 'twitter:description'
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: this.$seoUrl + this.$route.path
        },
        {
          rel: 'image_src',
          href: this.$defaultImage
        }
      ]
    }
  },
  data: () => ({
    loading: true,
    src: 'logo.png',
    showLoaderDialog: false,
    search: null,
    listCategories: [],
    expanded: [],
    singleExpand: true,
    categoryName: null,
    headers: [
      {text: 'عکس', value: 'MainOriginalFileUrl'},
      {text: 'نام', value: 'Name'},
      {text: 'نوع', value: 'TypeSearchResult'},
      {text: 'توضیحات', value: 'data-table-expand'},
      {text: '', value: 'actions'},
    ],
    list: [],
    pageSize: 10,
    pageIndex: 1,
    total: 0,
    targetPath: null,
    typePage: null,
  }),
  mounted() {
    this.getData()
  },
  watch: {
    '$route.query.KeyWord'() {
      location.reload()
    }
  },
  methods: {
    pageChangeEvent($event) {
      this.pageIndex = $event.page;
      this.pageSize = $event.itemsPerPage;
      if($event.itemsPerPage === -1){
        this.pageSize = this.total
      }

      this.getData();
      this.$scrollTop();
    },

    getData() {
      this.showLoaderDialog = true
      this.loading = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      var url = "/Client/Search?keyWord="

      url += this.$route.query.KeyWord


      url += "&pageIndex=" + this.pageIndex;


      url += "&pageSize=" + this.pageSize;


      fetch(this.$baseUrl + url, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.list = json.results
            this.total = json.totalCount;

            console.log("json")
            console.log(json)
            console.log(json.results)

            this.loading = false
            this.showLoaderDialog = false
          })
          .catch(error => console.log('error', error));
    },
    editContent(id, type) {

      if (type === 1) {
        this.targetPath = "ProductDetail"
      } else if (type === 2) {
        this.targetPath = "ContentDetail"
        this.typePage = 2
      } else if (type === 3) {
        this.targetPath = "ContentDetail"
        this.typePage = 1
      } else if (type === 4) {
        this.targetPath = "ContentDetail"
        this.typePage = 3
      }


      if (this.targetPath === "ProductDetail") {
        this.$router.push({path: this.targetPath, query: {productId: id}})
      } else {
        this.$router.push({path: this.targetPath, query: {id: id, type: this.typePage}})
      }
    }
  }

}
</script>

<style scoped>

</style>